<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('性别修改')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="sex">
      <van-radio-group v-model="radio">
        <div class="item van-hairline--bottom" @click="chooesSex(1)">
          <van-radio name="1">{{ $t('男') }}</van-radio>
        </div>
        <div class="item van-hairline--bottom" @click="chooesSex(2)">
          <van-radio name="2">{{ $t('女') }}</van-radio>
        </div>
      </van-radio-group>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    chooesSex(sex) {
      this.$http({
        method: 'post',
        data: {sex: sex},
        url: 'user_set_sex'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.radio = sex;
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.radio = res.data.sex;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .sex {
  background-color: #fff;
  padding: 0 40px;
}

.container .sex .item {
  font-size: 35px;
  line-height: 50px;
  padding: 30px 0;
}

::v-deep .van-radio__label {
  line-height: 50px;
  margin-left: 30px;
}

::v-deep .van-radio__icon {
  font-size: 30px;
}

::v-deep .van-radio__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}

.container .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 内容区域PC端适配
  .container .sex {
    padding: 0 23px; /* 40px * 0.5733 ≈ 23px */
  }

  .container .sex .item {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
    padding: 17px 0; /* 30px * 0.5733 ≈ 17px */
  }

  ::v-deep .van-radio__label {
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
    margin-left: 17px; /* 30px * 0.5733 ≈ 17px */
    font-size: 20px; /* 假设35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-radio__icon {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .container .van-hairline--bottom::after {
    border-bottom-width: 2px; /* 3px * 0.5733 ≈ 2px */
  }
}
</style>
